import { type ApiResponse } from "apisauce"

import { request } from "../../services/api"
import { type UserInfo } from "../LoginPage/types/auth.types.ts"
import {
  type UIPreferencesPatch,
  type UIPreferencesResponse
} from "./redux/ui-preferences.types.ts"

export type UserInfoResponse = UserInfo

export const getUserInfo = (): Promise<ApiResponse<UserInfoResponse>> =>
  request.api.get<UserInfoResponse>("/user/account/me/")

export const getUIPreferences = (): Promise<
  ApiResponse<UIPreferencesResponse>
> => request.api.get<UIPreferencesResponse>("/user/ui-preferences/")

export const patchUIPreferences = (
  payload: UIPreferencesPatch
): Promise<ApiResponse<UIPreferencesResponse>> =>
  request.api.patch<UIPreferencesResponse>("/user/ui-preferences/", payload)
